import React from 'react';
import { useAccessibility } from '../../contexts/AccessibilityContext';
import Text from '../../ui/Text/Text';
import { TextSizeEnum, ThemeEnum } from '../../utils/enums';

import './accessibilityHeader.scss';

const AccessibilityHeader: React.FC = () => {
  const { settings, setMode, setTheme, setTextSize, resetSettings } = useAccessibility();

  return (
    <div className='accessibility-header'>
      <div className='accessibility-header-holder container'>
        <div className='text-size-select'>
          <Text variant='body1' fontWeight={500} className='text-size-select-label'>
            Размер шрифта
          </Text>
          <div className='text-size-controls'>
            <label
              htmlFor='text-size-small'
              className='text-size-small'
              data-active={settings.textSize === TextSizeEnum.Small}
            >
              <input
                type='radio'
                id='text-size-small'
                name='text-size'
                value={TextSizeEnum.Small}
                checked={settings.textSize === TextSizeEnum.Small}
                onChange={(e) => setTextSize(e.target.value as TextSizeEnum)}
              />
              A
            </label>
            <label
              htmlFor='text-size-medium'
              className='text-size-medium'
              data-active={settings.textSize === TextSizeEnum.Medium}
            >
              <input
                type='radio'
                id='text-size-medium'
                name='text-size'
                value={TextSizeEnum.Medium}
                checked={settings.textSize === TextSizeEnum.Medium}
                onChange={(e) => setTextSize(e.target.value as TextSizeEnum)}
              />
              A
            </label>
            <label
              htmlFor='text-size-large'
              className='text-size-large'
              data-active={settings.textSize === TextSizeEnum.Large}
            >
              <input
                type='radio'
                id='text-size-large'
                name='text-size'
                value={TextSizeEnum.Large}
                checked={settings.textSize === TextSizeEnum.Large}
                onChange={(e) => setTextSize(e.target.value as TextSizeEnum)}
              />
              A
            </label>
          </div>
        </div>
        <div className='theme-select'>
          <div className='theme-select-controls'>
            <label
              htmlFor='theme-light'
              className='theme-light'
              data-active={settings.theme === ThemeEnum.Light}
              data-size={settings.textSize}
            >
              <input
                type='radio'
                id='theme-light'
                name='theme'
                value={ThemeEnum.Light}
                checked={settings.theme === ThemeEnum.Light}
                onChange={(e) => setTheme(e.target.value as ThemeEnum)}
              />
              A
            </label>
            <label
              htmlFor='theme-dark'
              className='theme-dark'
              data-active={settings.theme === ThemeEnum.Dark}
              data-size={settings.textSize}
            >
              <input
                type='radio'
                id='theme-dark'
                name='theme'
                value={ThemeEnum.Dark}
                checked={settings.theme === ThemeEnum.Dark}
                onChange={(e) => setTheme(e.target.value as ThemeEnum)}
              />
              A
            </label>
          </div>
          <Text variant='body1' fontWeight={500} className='theme-select-label'>
            Цветовая схема
          </Text>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityHeader;
